import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { Text } from '@fhs-legacy/universal-components';

import FallbackDeliveryTerms from './delivery-terms';
import { TermsLink } from './styled';

const LINK_TOKEN = '@@fhs-delivery-terms-link@@';

export default function DeliveryTerms() {
  const { formatMessage } = useIntl();
  const clickHereText = formatMessage({ id: 'clickHere' });
  const termsLinkAccessibilityLabel = 'Delivery Terms and Fees Apply. Click here for Details.';

  const [beforeLink, afterLink] = useMemo(() => {
    const s = formatMessage({ id: 'deliveryTerms' }, { link: LINK_TOKEN });
    if (typeof s !== 'string' || !s.includes(LINK_TOKEN)) {
      return [null, null] as const;
    }
    const i = s.indexOf(LINK_TOKEN);
    return [s.slice(0, i), s.slice(i + LINK_TOKEN.length)] as const;
  }, [formatMessage]);

  if (beforeLink == null || afterLink == null) {
    return <FallbackDeliveryTerms />;
  }

  return (
    <View style={styles.wrap}>
      <Text style={styles.segment} accessibilityRole="text">
        {beforeLink}
      </Text>
      <TermsLink
        to={formatMessage({ id: 'routes.deliveryTerms' })}
        isInline
        accessibilityLabel={termsLinkAccessibilityLabel}
      >
        {clickHereText}
      </TermsLink>
      <Text style={styles.segment} accessibilityRole="text">
        {afterLink}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
  },
  segment: {
    fontSize: 14,
    textAlign: 'center',
  },
});
